import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import {
  isFamilyResourcesPageInProgramFlex,
  isHighSchoolUrl,
  isMsSiteSelection,
  isK5SiteSelection,
} from 'utils/productHelpers'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

// TODO REMOVE MIDDLE SCHOOL JUNE RELEASE: middle school june release allows us to keep this flag checker on. So DO NOT turn off or remve this flag
// until we have a replacement for it. Used in multiple places so update all of them at once
const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'feature_LEARN-20164-k5-site-selection',
    'feature_LEARN-20108-ms-site-selection',
    'middle-school-june-release',
  ],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) =>
    isFamilyResourcesPageInProgramFlex() ||
    // allow for new HS Extension Activities
    isHighSchoolUrl() ||
    isMsSiteSelection(_, subscribedFlags) ||
    isK5SiteSelection(_, subscribedFlags),
})

export default FlagToggler
